module.exports = __webpack_public_path__ + "img/AIRWAYS3_main_logo_001.7158ba55.jpg";